module.exports = __webpack_public_path__ + "static/media/vrs3.63a75c55.png";